import * as go from 'gojs';
import { getPointString } from '../../../utils/stringify-utils';
import { GojsShadow } from '../models/gojs-shadow.model';

const parseShadowOffsetString = (shadowOffset: string) => {
  if (shadowOffset) {
    const { x, y } = go.Point.parse(shadowOffset);
    return { x, y };
  }

  return { x: 0, y: 0 };
};

export const gojsDataToShadowModel = (
  data: go.ObjectData,
  shadowBlurProp: string,
  shadowColorProp: string,
  shadowOffsetProp: string,
): GojsShadow => ({
  blur: data[shadowBlurProp],
  color: data[shadowColorProp],
  offset: parseShadowOffsetString(data[shadowOffsetProp]),
});

export const shadowModelToGojsData = (
  { blur, offset: { x, y }, color }: GojsShadow,
  shadowBlurProp: string,
  shadowColorProp: string,
  shadowOffsetProp: string,
) => ({
  [shadowBlurProp]: blur,
  [shadowColorProp]: color,
  [shadowOffsetProp]: getPointString(x, y),
});
